import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7949444c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7949444c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7949444c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7949444c')) {
      api.createRecord('7949444c', component.options)
    } else {
      api.reload('7949444c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7949444c&scoped=true", function () {
      api.rerender('7949444c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kx/bonus/index.vue"
export default component.exports